import { Observable } from 'rxjs';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { PayTransactionVNPService } from 'src/app/service/context/pay/pay-transaction-vnp.service';

@Component({
    selector: 'app-pay-transaction-vnp-recharge',
    templateUrl: './pay-transaction-vnp-recharge.component.html',
    styles: []
})
export class PayTransactionVNPRechargeComponent implements OnInit {
    constructor(
        private payTransVNPService: PayTransactionVNPService,
        private toastr: ToastrService,
        public datePipe: DatePipe
    ) { }

    users: any[] = [];
    myControl = new FormControl('');
    filteredOptions: Observable<any[]>;
    dateControlEnd = new FormControl(new Date());
    dateControlStart = new FormControl(new Date());

    trans: any[] = [];
    totalVNPAmount: any = 0;

    ngOnInit() {
        this.loadListFilterUser();

        this.loadData();
    }

    displayFn(user: any): string {
        return user && user.userName ? user.userName + (user.fullName ? ' - ' + user.fullName : '') : '';
    }

    private _filter(filter: string): any[] {
        const filterValue = filter.toLowerCase();

        return this.users.filter(option => option.userName.toLowerCase().includes(filterValue));
    }

    loadListFilterUser() {
        this.payTransVNPService.getListFilterUser().subscribe(
            res => {
                this.users = <any>res;

                this.filteredOptions = this.myControl.valueChanges.pipe(
                    startWith(''),
                    map(value => {
                        const filter = typeof value === 'string' ? value : (value ? value.filter : null);
                        return filter ? this._filter(filter as string) : this.users.slice();
                    }),
                );
            },
            err => {
                this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
            },
        );
    }

    loadData() {
        document.getElementById('page-loader-data').style.display = "block";
        let params = {
            "userName": this.myControl && this.myControl.value ? this.myControl.value.userName : "",
            "startDateInput": this.datePipe.transform(this.dateControlStart.value, 'yyyy-MM-dd'),
            "endDateInput": this.datePipe.transform(this.dateControlEnd.value, 'yyyy-MM-dd'),
        }
        this.payTransVNPService.getListTransRecharge(params).subscribe(
            res => {
                this.trans = <any>res;

                this.totalVNPAmount = this.trans.reduce((sum, current) => sum + current.vnpAmount, 0);
                document.getElementById('page-loader-data').style.display = "none";
            },
            err => {
                this.toastr.error(err.error ? err.error.message : JSON.stringify(err), 'Lỗi.');
                document.getElementById('page-loader-data').style.display = "none";
            },
        );
    }

    onRefresh() {
        this.loadData();
    }
}